import { useState } from 'react';
import dayjs from 'lib/dayjs';
import Icon from '../AppIcon';

// Date cell of an unplanned leave: one day is shown as is; several days show the first day with a
// "N days" badge and a dropdown that lists every day (same pattern as the leave request table).
const UnplannedDatesCell = ({ dates = [], className = '' }) => {
  const [open, setOpen] = useState(false);
  if (dates.length === 0) return null;

  if (dates.length === 1) {
    return <p className={`font-medium ${className}`}>{dayjs(dates[0]).format('DD MMM YYYY')}</p>;
  }

  return (
    <div>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 text-left"
        aria-expanded={open}
      >
        <span className={`font-medium ${className}`}>{dayjs(dates[0]).format('DD MMM YYYY')}</span>
        <span className="rounded bg-blue-100 px-1.5 py-0.5 text-xs font-medium text-blue-700">
          {dates.length} days
        </span>
        <Icon
          name="ChevronDown"
          size={14}
          className={`text-blue-600 transition-transform ${open ? 'rotate-180' : ''}`}
        />
      </button>
      {open && (
        <ul className="mt-2 space-y-1 text-xs text-gray-600">
          {dates.map((d) => (
            <li key={d} className="flex items-center gap-1.5">
              <Icon name="Calendar" size={12} className="text-gray-400" />
              {dayjs(d).format('ddd, DD MMM YYYY')}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default UnplannedDatesCell;
